import { FC, SVGProps, useMemo } from 'react';

import useConfiguration from '~/redux/hooks/useConfiguration';

import { ReactComponent as discord } from '~/assets/images/social-media/discord.svg';
import { ReactComponent as facebook } from '~/assets/images/social-media/facebook.svg';
import { ReactComponent as instagram } from '~/assets/images/social-media/instagram.svg';
import { ReactComponent as tiktok } from '~/assets/images/social-media/tiktok.svg';
import { ReactComponent as twitch } from '~/assets/images/social-media/twitch.svg';
import { ReactComponent as twitter } from '~/assets/images/social-media/twitter.svg';
import { ReactComponent as youtube } from '~/assets/images/social-media/youtube.svg';

const socialMediaData = {
  discord: { icon: discord, label: 'MenuView_socials_discord' },
  facebook: { icon: facebook, label: 'MenuView_socials_facebook' },
  instagram: { icon: instagram, label: 'MenuView_socials_instagram' },
  twitch: { icon: twitch, label: 'MenuView_socials_twitch' },
  twitter: { icon: twitter, label: 'MenuView_socials_twitter' },
  youtube: { icon: youtube, label: 'MenuView_socials_youtube' },
  tiktok: { icon: tiktok, label: 'MenuView_socials_tiktok' },
} as const;

export function useSocialMedia(): null | Array<{
  Icon: FC<SVGProps<SVGSVGElement>>;
  url: string;
  label: string;
}> {
  const { socialMedia } = useConfiguration() as {
    socialMedia?: Record<Lowercase<string>, string>;
  };

  return useMemo(() => {
    if (!socialMedia) {
      return null;
    }
    return (Object.keys(socialMedia) as Array<keyof typeof socialMediaData>)
      .filter((key) => socialMediaData[key])
      .map((key) => ({
        label: socialMediaData[key].label,
        url: socialMedia[key],
        Icon: socialMediaData[key].icon,
      }));
  }, [socialMedia]);
}
